<template>
    <div class="upsell-options">
        <ul>
            <li v-for="product in upsellData.products">
                <product-tile
                    :key="product.id"
                    :product="product"
                    :isMobile="isMobile">
                </product-tile>
            </li>
        </ul>
    </div>
</template>

<script src='./upsell-page.js'></script>
